import type { Participant } from 'livekit-client';

/**
 * Валидирует наличие SID у участника
 * @returns SID участника или null если отсутствует
 */
export const validateParticipantSid = (participant: Participant): string | null => {
    return participant.sid || null;
};

/**
 * Проверяет наличие SID у участника и возвращает его или выбрасывает предупреждение
 * @returns SID участника или null если отсутствует
 */
export const requireParticipantSid = (participant: Participant, actionName: string): string | null => {
    const sid = validateParticipantSid(participant);
    if (!sid) {
        console.warn(`[Moderation] не удалось выполнить ${actionName}: отсутствует SID участника`, {
            participantIdentity: participant.identity,
            participantKind: participant.kind,
            isLocal: participant.isLocal,
        });
    }
    return sid;
};
